var $ca275c3dfdc04bbf$exports = {};
$ca275c3dfdc04bbf$exports = {
    "more": `Wi\u{119}cej element\xf3w`
};


export {$ca275c3dfdc04bbf$exports as default};
//# sourceMappingURL=pl-PL.mjs.map
